import * as React from 'react';

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  label: string;
}

export function VerificationCodeInput(props: Props) {
  const { value, onChange, disabled, label } = props;
  const normalizedValue = String(value || '')
    .replace(/\D/g, '')
    .slice(0, 6);

  return (
    <input
      className="eVerifyCodeInput"
      aria-label={label}
      inputMode="numeric"
      autoComplete="one-time-code"
      maxLength={6}
      disabled={disabled}
      value={normalizedValue}
      onFocus={event => event.currentTarget.select()}
      onChange={event => onChange(event.target.value.replace(/\D/g, '').slice(0, 6))}
      placeholder="000000"
    />
  );
}
